import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import tableForm from './tableForm';
import tableFormOrder from './tableFormOrder';
import myrender from './myrender';
import lSearch from './search';

export default {
  name: 'table-render',
  mixins: [pageInation, makeSure],
  provide() {
    return {
      indexPage: this.indexPage || {},
      main: this
    };
  },
  inject: {
    indexPage: {
      from: 'indexPage',
      default: {}
    }
  },
  props: {
    rowClassName: {
      type: Function,
      default: () => {
        return void 0;
      }
    },
    setPageSize: {
      type: Number,
      default: 0
    },
    list: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hidePagination: {
      type: Boolean,
      default: false
    },
    config: { type: Array, default: () => [] },
    propData: {
      type: Object,
      default: () => {}
    }, // {query} 主要用于页面通用参数与当前part 需重构
    getListFinished: {
      type: Function
    }
  },
  data() {
    return {
      dialogFooter: false,
      dialogName: null,
      dialogDate: [],
      dialogVisible: false,
      dialogTitle: '',
      fromJump: false,
      currChild: null,
      tips: '暂无数据',
      showBox: false,
      activeName: '',
      getListFn: null,
      activeIndex: 0,
      childActiveIndex: 0,
      content: this.config,
      getList: null, // 获取列表的AJAX
      searchQuery: {},
      partName: 'surveyDetail',
      searchComponent: lSearch,
      partDate: {},
      partProps: {},
      test: {},
      dialogWidth: '90%',
      defaultQuery: {}, // 用于不同part中的参数
      defaultQueryHotfix: {},
      searchItem: null,
      beforeSearch: () => {},
      selection: []
    };
  },
  watch: {
    '$route.query'(val, from) {
      if (from.detail && from.detail != '' && !val.detail) {
        this.showBox = false;
        this.partDate.formData = {};
      }
    },
    activeIndex(nval, oval) {
      this.childActiveIndex = 0;
      this.formPageDate();
      if (+nval !== +oval) {
        this.$emit('changeActive', nval);
      }
    },
    childActiveIndex(v) {
      this.formPageDate();
      this.$emit('changeChildActive', v);
    }
  },
  components: {
    tableForm,
    myrender,
    lSearch,
    tableFormOrder
  },
  computed: {
    // searchItem(){
    //   return this.content[this.activeIndex].childMenu[this.childActiveIndex].search
    // },
    moreBtnArr() {
      return this.content[this.activeIndex].childMenu[this.childActiveIndex]
        .moreBtnArr;
    },
    showClearAll() {
      return this.content[this.activeIndex].childMenu[this.childActiveIndex]
        .showClearAll;
    }
  },
  methods: {
    //单元格被点击时会触发该事件
    cellClick(row, column, cell, event) {
      this.$emit('handCellClick', { row, column, cell, event });
    },
    //通用回调
    close() {
      this.handleDialogClose();
    },
    //确定
    makeSureHandle(query, callback) {
      let makeSureEvent = scope => {
        callback(scope).then(() => {
          this.$notify({
            title: '成功',
            message: '操作成功',
            type: 'success'
          });
          //todo 这里要初始化搜索
          this.initWatchRouteChange(this.paginationData.pageNo);
        });
      };
      this.makeSureEvent(makeSureEvent, query);
    },
    // 不更改本身页面
    reGetPage(moreParams) {
      this.syncConfig();
      this.getPageList(this.paginationData.pageNo, true, moreParams);
    },
    tableCallback(callback, arg) {
      if (typeof callback === 'function') {
        callback.call(this, arg);
      } else {
        console.error('请传入函数参数!');
      }
    },
    //处理对话框模板加载
    showDialog(target, query, props) {
      this.dialogName = target.component;
      this.dialogWidth = target.width || '90%';
      this.dialogTitle = target.title || '';
      this.dialogDate = query;
      this.partProps = props || {};
      this.dialogVisible = true;
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.dialogName = null;
      this.dialogDate = [];
    },
    //处理页面内详情的逻辑
    showDetail(target, config, props) {
      this.partName = target.component;
      this.partDate = config;
      this.partProps = props || {};
      this.showBox = true;
    },
    closeDetail() {
      this.partName = null;
      this.partDate = [];
      this.showBox = false;
      this.$nextTick(() => {
        this.initWatchRouteChange();
      });
    },
    //处理搜索
    handleSearch(e) {
      Object.keys(this.searchQuery).forEach(res => {
        if (res !== 'pageNo' || res !== 'pageSize') {
          this.$delete(this.searchQuery, res);
        }
      });
      this.searchQuery = Object.assign(
        {},
        this.defaultQuery, // 权重最低，多part时为每项单独的query 方便单独写死默认值
        (this.propData || {}).query || {}, // 多项时用于当前part默认值(不关心part几，通过父级$route.quer等赋值)并且再tab切换时会清空该项，便于defaultQuery重叠的默认值。单part时与defaultQuery一样
        e,
        this.searchQuery, // 执行后只有分页
        this.defaultQueryHotfix
      );
      this.tips = this.childActiveIndex === 0 ? '暂无数据' : '暂无数据';
      this.$emit('handleSearch', this.searchQuery);
      this.searchEvent();
    },
    handBeforeSearch(row, searchItem) {
      this.$emit('handBeforeSearch', row, searchItem);
    },
    handleClick(tab) {
      if (this.loading) {
        this.$nextTick(() => {
          this.activeName = this.content[this.activeIndex].name;
        });
        return;
      }
      // 切换后初始参数
      this.propData && this.propData.query && (this.propData.query = {});
      this.$emit('tabChange', tab.index);
      this.activeIndex = tab.index;
    },
    handleChildClick(index) {
      if (this.loading) {
        this.content[this.activeIndex].childMenu;
        return;
      }
      this.clearTableSelection();
      this.childActiveIndex = index;
    },
    changePage(nowPage) {
      this.page = nowPage;
      this.arr = [];
      this.getPageList(1);
    },
    // 同步config参数
    syncConfig() {
      if (
        !this.content ||
        (Array.isArray(this.content) && this.content.length <= 0)
      ) {
        return;
      }
      // this.tableData = [];
      this.searchCtrl++;
      try {
        this.searchQuery = {};
        if (this.propData) {
          let propDataQuery = this.propData.query || {};
          this.fromJump = this.propData.fromJump || false;
          Object.assign(this.searchQuery, propDataQuery);
          // 一级 part跳转，对应下标
          if (propDataQuery.part) {
            // this.activeIndex = +this.propData.query.part;
          }
          let { fromInvoice } = propDataQuery;
          if (fromInvoice) {
            let targetChildIndex = this.propData.query.part || 0;
            delete this.propData.query.fromInvoice;
            delete this.propData.query.part;
            this.activeIndex = targetChildIndex;
            return;
          }
        }
        // this.totalElements = 0;
        this.target = this.content[this.activeIndex || 0];
        this.activeName = this.target.name;
        let currChild = this.target.childMenu[this.childActiveIndex || 0];
        this.currChild = currChild;
        this.tableHeader = currChild.fields;
        this.getList = this.getListFn = currChild.list;
        this.defaultQuery = currChild.defaultQuery;
        this.defaultQueryHotfix = currChild.defaultQueryHotfix;
        this.searchComponent = currChild.searchComponent || lSearch;
        this.test = Object.assign(
          {
            cs: 1,
            t: +new Date()
          },
          currChild.defaultQuery || {}
        );
        this.partName = currChild.detailType || '';
        this.searchItem = currChild.search;
        this.beforeSearch = currChild.beforeSearch;
        //混入 defaultQuery
        this.searchQuery = { ...this.searchQuery, ...this.defaultQuery };
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    // 处理变化
    async formPageDate() {
      await this.syncConfig();
      this.handleSearch();
    },
    init() {
      this.$nextTick(() => {
        this.tableData.length = 0;
        // 根据part设置tab位置，之后清除part
        if (this.propData && this.propData.query && this.propData.query.part) {
          this.activeIndex = this.propData.query.part;
          delete this.propData.query.part;
        } else {
          this.formPageDate();
        }
        this.$emit('tabChange', this.activeIndex);
      });
    },
    /**
     * @description: 通过外部全选按钮,拉取全部数据在同步到selection中
     * @param {object} arg {listAjax,listAjaxQuery,useSeachQuery,useSeachInit,superKeys} 全选列表接口,自定义参数列表接口,是否使用搜索的参数,是否初始列表,使用该数据不调用接口
     * @return resolve
     */
    async selectAllByRowKey(arg) {
      let { $attrs, $refs } = this;
      let { search: searchRef, table: tableRef } = $refs;
      if (Object.prototype.toString.call(arg) !== '[object Object]') {
        throw new Error('selectAllByRowKey方法需要传入对象');
      }
      if (!$attrs.rowKey) {
        throw new Error(
          'selectAllByRowKey方法使用前必须定义tableRender中rowKey属性'
        );
      }
      // 初始参数
      let _arg = {
        listAjax: null,
        useSeachQuery: true,
        useSeachInit: true,
        listAjaxQuery: {},
        superKeys: null,
        ...arg
      };
      let {
        listAjax,
        useSeachQuery,
        useSeachInit,
        listAjaxQuery,
        superKeys
      } = _arg;
      // 重新搜索, 并刷新列表
      if (useSeachInit) {
        try {
          searchRef.sure();
        } catch (e) {
          // TODO: 生成订单弹层会报错，元素未获取到，暂未处理。（暂无影响）
          console.error('searchRef.sure error:', e);
        }
      }
      // 获取当前table中的选项
      let _selection = tableRef.store.states.selection;
      // 请求参数
      let query = { ...(useSeachQuery && this.searchQuery), ...listAjaxQuery };

      try {
        let data = [];
        if (superKeys) {
          data = superKeys;
        } else {
          let {
            data: { data: resp }
          } = await listAjax(query);
          data = resp;
        }
        // 如果已存在选项内容则需要过滤
        if (_selection.length) {
          // selection 中rowKey集合
          let selecctionIds = _selection.map(item => item[$attrs.rowKey]);
          // 过滤掉以选择的数据
          let pushArr = data.filter(item => {
            return !selecctionIds.includes(item[$attrs.rowKey]);
          });
          _selection.push.apply(_selection, pushArr);
        } else {
          _selection.push.apply(_selection, data);
        }
        // 解决多个tableRender切换后，rowKey在el store中没有同步修改的问题
        if (tableRef.store.states.rowKey !== $attrs.rowKey) {
          tableRef.store.states.rowKey = $attrs.rowKey;
        }
        // 更新Selection中的数据引用
        tableRef.store.updateSelectionByRowKey();
        return Promise.resolve(_selection);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    /*
        调用el-table中clearSelection时有问题，该方法是直接selection = []改变了引用，所以在select事件中还需要在指向下引用
        并且需要清空当前data中selection变量
    */
    clearTableSelection() {
      this.$refs.table.clearSelection();
    }
  },
  mounted() {
    this.init();
  }
};
